module.exports = __webpack_public_path__ + "img/PjiliAuctions.3088cbbe.svg";